import React from 'react';

const CirclePlusIcon = ({ width, height, ...rest }) => (
  <svg width={width} height={height} viewBox="0 0 36 36" color="inherit" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M18 31.5C25.4558 31.5 31.5 25.4558 31.5 18C31.5 10.5442 25.4558 4.5 18 4.5C10.5442 4.5 4.5 10.5442 4.5 18C4.5 25.4558 10.5442 31.5 18 31.5Z"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12.375 18H23.625" stroke="inherit" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 12.375V23.625" stroke="inherit" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CirclePlusIcon;
